import { render, staticRenderFns } from "./UserGroupList.vue?vue&type=template&id=69fcb21f"
import script from "./UserGroupList.vue?vue&type=script&lang=ts"
export * from "./UserGroupList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports